define('lib/3dImagesRandomColor',[], function() {
  /*
  Get the image path of a random color from the 3dImageService
  returns a string

  (color [,size] [,angleNum])
    colorsObj:
      object(exteriorcolor (or interiorcolor?) obj from the 3dImageService
    size:
      string, possible values: '380_214_PNG', '680_383_PNG', '864_477_PNG'
    angleNum:
      number, possible values: 1,2,3,4
  */

  return function randomColor(colorsObj, size, angleNum){
    size = size || '380_214_PNG';
    angleNum = angleNum || 1;
    var availableColorsArr = Object.keys(colorsObj); // array of keys from the above obj
    // Only use colors that have a 3dimage (some do not!!)
    var has3dImage = [];
    for (var i = 0; i < availableColorsArr.length; i++){
      // If this color contains an obj with a key of '3dimage', then it's safe to use
      if ('3dimage' in colorsObj[availableColorsArr[i]]){
        has3dImage.push(availableColorsArr[i]);
      }
    }
    var randColor = has3dImage[Math.floor(Math.random() * has3dImage.length)];
    return colorsObj[randColor]['3dimage'][size][angleNum][0];
  }
});

